/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Irrigation_Schedule_Warning_Tight_GapInputs */

const vi_irrigation_schedule_warning_tight_gap = /** @type {(inputs: Irrigation_Schedule_Warning_Tight_GapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Có lần tưới cách lần trước dưới 2 phút. Để bảo vệ máy bơm, hệ thống phải nghỉ ít nhất 1 phút giữa hai lần bật, nên lần tưới sau có thể bị bỏ qua. Nên để các lần tưới cách nhau từ 2 phút trở lên.`)
};

/**

* @param {Irrigation_Schedule_Warning_Tight_GapInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const irrigation_schedule_warning_tight_gap = /** @type {((inputs?: Irrigation_Schedule_Warning_Tight_GapInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Irrigation_Schedule_Warning_Tight_GapInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_irrigation_schedule_warning_tight_gap(inputs)
});